export default "__VITE_ASSET__DwemWfTw__"